import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import resetScroll from 'teacher-ui-client/modifiers/reset-scroll'
import type ReportingReadingEggsController from 'teacher-ui-client/reporting/ui-scope/re/controller'

interface Signature {
  Args: {
    controller: ReportingReadingEggsController
  }
}

export const ReportingUiScopeRePage: TOC<Signature> = <template>
  <div
    class="{{if @controller.isDashboardTable 'relative flex flex-col'}} w-full"
    {{resetScroll onSetup=true onRouterChange=true}}
  >
    {{outlet}}
  </div>
</template>

export default RouteTemplate(ReportingUiScopeRePage)
